var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetmenuCharts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_17918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16H5.33333C4.59695 16 4 16.597 4 17.3333V25.3333C4 26.0697 4.59695 26.6667 5.33333 26.6667H10.6667C11.403 26.6667 12 26.0697 12 25.3333V17.3333C12 16.597 11.403 16 10.6667 16Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 10.6667H13.3333C12.597 10.6667 12 11.2636 12 12V25.3334C12 26.0697 12.597 26.6667 13.3333 26.6667H18.6667C19.403 26.6667 20 26.0697 20 25.3334V12C20 11.2636 19.403 10.6667 18.6667 10.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 5.33331H21.3333C20.597 5.33331 20 5.93027 20 6.66665V25.3333C20 26.0697 20.597 26.6666 21.3333 26.6666H26.6667C27.403 26.6666 28 26.0697 28 25.3333V6.66665C28 5.93027 27.403 5.33331 26.6667 5.33331Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 26.6667H24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_17918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetmenuCharts);
export default __webpack_public_path__ + "static/media/widgetmenu_charts.4e67c11c4927d5b038ac8d45f7745ec8.svg";
export { ForwardRef as ReactComponent };